import { AccountGroupsFormVM } from './account-groups-form.viewmodel';
import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { AccountGroupsFormPresentation } from './_account-group-form-presentation/account-groups-new-form-presentation';

interface IProps {
    fetchAccountGroupsList: () => void;
    closeEditGroupForm: (accountGroupId: number) => void;
    accountGroupId: number;
}

const AccountGroupsFormContainer = withViewModel(
    AccountGroupsFormPresentation,
    (props: IProps) => {
        const { fetchAccountGroupsList, closeEditGroupForm, accountGroupId } = props;
        const accountGroupsFormVM = new AccountGroupsFormVM(fetchAccountGroupsList, closeEditGroupForm);
        accountGroupsFormVM.initGroup(accountGroupId);
        return accountGroupsFormVM;
    },
    () => []
);

export { AccountGroupsFormContainer as AccountGroupsForm };
